module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Cc-Db-Ee-Fb-Gb.85d2fac7.png";